// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"e4-z","dimensionLabel":"f4-z","styleChooserControlWrapper":"g4-z","styleChooserControl":"h4-z","disabled":"i4-z","giftCard":"j4-z","styleChooserText":"k4-z"};